import { SmartObjectDate as SmartObjectDateBase } from '@max/tiptap-extensions'
import { VueNodeViewRenderer } from '@tiptap/vue-2'
import SmartObjectDateNodeView from '@/components/editor/SmartObjectDateNodeView'

export const SmartObjectDate = SmartObjectDateBase.extend({
    addNodeView () {
        return VueNodeViewRenderer(SmartObjectDateNodeView)
    },
})
